import {
	Box,
	Divider,
	FormHelperText,
	TextField,
	Table,
	TableContainer,
	TableBody,
	TableCell,
	tableCellClasses,
	TableHead,
	TableRow,
	ToggleButtonGroup,
	ToggleButton,
	Grid,
	Typography,
	Button,
	Paper,
} from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React, { useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cssVariables from "../../../../theme/cssVariables";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";

import { ReactComponent as PlusIcon } from "../../../../icons/plus-bigger.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as AlertRed } from "../../../../icons/alert-red.svg";
import { ReactComponent as MoveIcon } from "../../../../assets/icons/move.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info.svg";
import { ReactComponent as ApprovedIcon } from "../../../../assets/images/iconStatus/approved.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar-month.svg";
import Person from "../../../../icons/avatar.svg";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import IOSSwitch from "../../../../components/IOSSwitch";
import RedStarRequired from "../../../../components/RedStarRequired";

import {
	DragDropContext,
	Droppable,
	Draggable
} from 'react-beautiful-dnd';

import WorkflowDialog from "../../../../components/adminConfigWorkflow/WorkflowDialog";
import MessageDialog from "../../../../components/MessageDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";

import { getWorkflow, getWorkflowTemplate, postCreateWorkflow, postWorkflowStep, putWorkflowStep, deleteWorkflowStep, putWorkflow, getWorkflowStep } from "../../../../actions/admin/workflow";

const useStyles = makeStyles({
	root: {
		display: "flex",
		width: "100%",
		flexWrap: "wrap",
	},
	tableHeader: {
		fontWeight: 500,
		fontSize: "14px!important",
		color: "#A0A0A0",
	},
	paperRoot: {
		paddingTop: "24px!important",
		paddingBottom: "24px!important",
		paddingLeft: "32px!important",
		paddingRight: "32px!important",
		boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)!important",
		borderRadius: "10px!important",
	}
})

const BootstrapTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: "#343A40",
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "#343A40",
		color: "#FFFFFF",
		padding: "11px 15px",
	},
}));

const StyledPaper = (props) => {
	const classes = useStyles();
	return (
		<Paper
			classes={{ root: classes.paperRoot }}
			{...props}
		>
			{props.children}
		</Paper>
	);
};

const StyledTableCellEvaluate = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: "#FAFAFA",
		borderTop: "1px solid #E5E5E5!important",
		borderBottom: "1px solid #E5E5E5!important",
		borderLeft: "0!important",
		borderRight: "0!important",
	},
	[`&.${tableCellClasses.head}:nth-of-type(6)`]: {
		padding: "0!important",
	},
	[`&.${tableCellClasses.body}`]: {
		backgroundColor: "#FFF",
		fontSize: 14,
	},
	"&:nth-of-type(1)": {
		width: "5%",
	},
	"&:nth-of-type(2)": {
		width: "5%",
	},
	"&:nth-of-type(3)": {
		width: "15%",
	},
	"&:nth-of-type(4)": {
		width: "20%",
	},
	"&:nth-of-type(5)": {
		width: "21%",
	},
	"&:nth-of-type(6)": {
		width: "6%",
	},
	"&:nth-of-type(7)": {
		width: "6%",
	},
	"&:nth-of-type(8)": {
		width: "6%",
	},
	"&:nth-of-type(9)": {
		width: "6%",
	},
	"&:nth-of-type(10)": {
		width: "10%",
	},
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
}))

const getItemStyle = (isDragging, draggableStyle) => ({
	userSelect: "none",
	background: "#FFF",
	boxShadow: "10px 10px 13px -4px rgba(0,0,0,0.34)",
	WebkitBoxShadow: "10px 10px 13px -4px rgba(0,0,0,0.34)",
	MozBoxShadow: "10px 10px 13px -4px rgba(0,0,0,0.34)",
	...draggableStyle
});

const StyledTableEvaluate = (props) => {
	const classes = useStyles();
	const { t } = useTranslation()
	const { doEdit, doDelete, setEnable, doSortList, isStepValid, ...oProps } = props
	let dataList = oProps?.data ?? []
	const CellData = (rProps) => {
		let { list } = rProps
		let fieldsLength = list?.fields?.length > 0 ? list.fields.length : 1
		return (
			<>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{<CustomCheckbox error={!isStepValid} checked={list?.status === "active" ? true : false} onChange={() => setEnable(list.step)} sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} />}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{list?.step || ""}
					</Typography>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{list?.action?.label || ""}
					</Typography>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" sx={fieldsLength > 1 ? { borderLeft: "1px solid rgba(224, 224, 224, 1)", borderRight: "1px solid rgba(224, 224, 224, 1)" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{list?.fields?.length > 0 ? list?.fields[0]?.label : ""}
					</Typography>
					{
						(list?.fields?.length > 0 && list?.fields[0]?.value) &&
						<Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
							{list?.fields[0]?.value?.name || ""}
						</Typography>
					}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							height: "fit-content",
							minHeight: "50px"
						}}
					>
						<Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
							{list?.description?.en || ""}
						</Typography>
						<Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
							{list?.description?.th || ""}
						</Typography>
					</Box>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.step > 1 && list?.options?.hide_score_self) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.action?.code === "approve" && list?.options?.reject) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.step !== 1 && list?.options?.edit) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{list?.is_send_mail ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
			</>
		)
	}

	return (
		<TableContainer component={"div"} {...props}>
			<DragDropContext onDragEnd={doSortList}>
				<Droppable droppableId="droppable-list">
					{provided => (
						<Table sx={{ minWidth: 650 }} aria-label="data table" {...provided.droppableProps} ref={provided.innerRef}>
							<TableHead>
								<StyledTableRow>
									<StyledTableCellEvaluate align="left">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.enable")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="left">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.seq")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="left">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.action")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="left">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.field")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="left">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.description")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="center">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.hideScoreToSelf")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="center">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.reject")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="center">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.editable")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="center">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.email")}
										</Typography>
									</StyledTableCellEvaluate>
									<StyledTableCellEvaluate align="left">
										<Typography classes={{ root: classes.tableHeader }}>
											{t("adminWorkflow.label.action")}
										</Typography>
									</StyledTableCellEvaluate>
								</StyledTableRow>
							</TableHead>
							<TableBody>
								{dataList.map((list, index) => {
									let fieldsLength = list?.fields?.length > 0 ? list.fields.length : 1
									if (list.action?.code !== "submit" && list.action?.code !== "evaluate" && list.action?.code !== "signoff") {
										return (
											<>
												<Draggable draggableId={`row-${index}`} index={index} key={`draggable-${index}`}>
													{(provided, snapshot) => {
														if (fieldsLength >= 0 && fieldsLength <= 1) {
															return (
																<StyledTableRow
																	ref={provided.innerRef}
																	{...provided.draggableProps}
																	style={getItemStyle(
																		snapshot.isDragging,
																		provided.draggableProps.style
																	)}
																>
																	<CellData list={list} />
																	<StyledTableCellEvaluate align="left">
																		<Box sx={{ display: "flex", flexDirection: "space-between" }}>
																			<Box sx={{ display: "flex", alignItems: "center" }}>
																				<BootstrapTooltip
																					title={t("label.edit")}
																					placement="top"
																				>
																					<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEdit(list)} />
																				</BootstrapTooltip>
																			</Box>
																			<Box sx={{ display: "flex", flexDirection: "space-between" }} {...provided.dragHandleProps}>
																				<BootstrapTooltip
																					title={t("label.move")}
																					placement="top"
																				>
																					<MoveIcon />
																				</BootstrapTooltip>
																			</Box>
																		</Box>
																	</StyledTableCellEvaluate>
																</StyledTableRow>
															)
														} else if (fieldsLength > 1) {
															let result = []
															list.fields.forEach(fieldRow => {
																if (index === 0) {
																	result.push(
																		<StyledTableRow
																			ref={provided.innerRef}
																			{...provided.draggableProps}
																			style={getItemStyle(
																				snapshot.isDragging,
																				provided.draggableProps.style
																			)}
																		>
																			<CellData list={list} />
																			<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
																				<Box sx={{ display: "flex", flexDirection: "space-between" }}>
																					<Box sx={{ display: "flex", alignItems: "center" }}>
																						<BootstrapTooltip
																							title={t("label.edit")}
																							placement="top"
																						>
																							<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEdit(list)} />
																						</BootstrapTooltip>
																					</Box>
																				</Box>
																			</StyledTableCellEvaluate>
																		</StyledTableRow>
																	)
																} else {
																	result.push(
																		<StyledTableRow
																			ref={provided.innerRef}
																			{...provided.draggableProps}
																			style={getItemStyle(
																				snapshot.isDragging,
																				provided.draggableProps.style
																			)}
																		>
																			{/* value data */}
																			<StyledTableCellEvaluate align="left" sx={{ borderLeft: "1px solid rgba(224, 224, 224, 1)", borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
																				<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
																					{fieldRow.label}
																				</Typography>
																				{
																					(fieldRow?.value) &&
																					<Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
																						{fieldRow?.value?.name || ""}
																					</Typography>
																				}
																			</StyledTableCellEvaluate>
																		</StyledTableRow>
																	)
																}
															})
															return result
														}
													}}
												</Draggable>
												{provided.placeholder}
											</>
										)
									} else {
										if (fieldsLength >= 0 && fieldsLength <= 1) {
											return (
												<StyledTableRow>
													<CellData list={list} />
													<StyledTableCellEvaluate align="left" rowSpan={fieldsLength}>
														<Box sx={{ display: "flex", flexDirection: "space-between" }}>
															<Box sx={{ display: "flex", alignItems: "center" }}>
																<BootstrapTooltip
																	title={t("label.edit")}
																	placement="top"
																>
																	<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEdit(list)} />
																</BootstrapTooltip>
															</Box>
														</Box>
													</StyledTableCellEvaluate>
												</StyledTableRow>
											)
										} else if (fieldsLength > 1) {
											let result = []
											list.fields.forEach((fieldRow, index) => {
												if (index === 0) {
													result.push(
														<StyledTableRow>
															<CellData list={list} />
															<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
																<Box sx={{ display: "flex", flexDirection: "space-between" }}>
																	<Box sx={{ display: "flex", alignItems: "center" }}>
																		<BootstrapTooltip
																			title={t("label.edit")}
																			placement="top"
																		>
																			<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEdit(list)} />
																		</BootstrapTooltip>
																	</Box>
																</Box>
															</StyledTableCellEvaluate>
														</StyledTableRow>
													)
												} else {
													result.push(
														<StyledTableRow>
															{/* value data */}
															<StyledTableCellEvaluate align="left" sx={{ borderLeft: "1px solid rgba(224, 224, 224, 1)", borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
																<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
																	{fieldRow.label}
																</Typography>
																{
																	(fieldRow?.value) &&
																	<Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
																		{fieldRow?.value?.name || ""}
																	</Typography>
																}
															</StyledTableCellEvaluate>
														</StyledTableRow>
													)
												}
											})
											return result
										}
									}
								})
								}
							</TableBody>
						</Table>
					)}
				</Droppable>
			</DragDropContext>
		</TableContainer>
	)
}

const ErrorHelper = () => {
	const { t } = useTranslation();
	return (
		<Grid container mt={0}>
			<Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
				<AlertRed />
				<FormHelperText
					error={true}
					sx={{ ml: 1 }}
				>
					{t("label.pleaseFillOutThisField")}
				</FormHelperText>
			</Grid>
		</Grid>)
}

const EvaluationWorkflow = (props) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { state } = useLocation()
	const { id, mode } = props

	const [workflowId, setWorkflowId] = React.useState("")
	const [workflowData, setWorkflowData] = React.useState("")
	const [stepList, setStepList] = React.useState([])
	const [isStepListEmptyDialogOpen, setIsStepListEmptyDialogOpen] = React.useState(false)
	const [isStepValid, setIsStepValid] = React.useState(false)

	const goToAdmin = (route, data) => {
		if (data) {
			navigate("/admin" + route, { replace: false, state: data });
		} else {
			navigate("/admin" + route, { replace: false });
		}
	}

	// formik validation
	const validationSchema = yup.object({
		code: yup.string().min(1).required(),
		type: yup.string().min(1).required(),
		name: yup.string().min(1).required(),
		status: yup.boolean().required(),
		description: yup.string().min(1).required(),
	});
	const formik = useFormik({
		initialValues: {
			code: "",
			type: "",
			name: "",
			status: true,
			description: "",
			type: ""
		},
		enableReinitialize: true,
		validationSchema: validationSchema,
		onSubmit: () => {
			console.log("submit")
			if (stepList.length > 0 && isStepValid) {
				if (mode === "edit") {
					handleSubmitUpdate()
				} else {
					handleSubmitCreate()
				}
			}
			// do create or update here
		},
	})

	// preview lang & data
	const [previewLang, setPreviewLang] = React.useState("EN");
	const handleChangePreviewLang = (e, val) => {
		setPreviewLang(val);
	}
	const [isConfirmDiscardDialogOpen, setIsconfirmDiscardDialogOpen] = React.useState(false)
	const handleConfirmDiscard = () => {
		setIsconfirmDiscardDialogOpen(false, goToAdmin("/workflow"))
	}

	// workflow dialog
	const [isWorkflowDialogOpen, setIsEvaluationWorkflowDialogOpen] = React.useState(false)
	const [countStep, setCountStep] = React.useState(0)
	const handleAddStep = () => {
		setTypeWorkflowTemplate("add")
		setIsEvaluationWorkflowDialogOpen(true)
	}
	const handleCloseWorkflowDialog = () => {
		setIsEvaluationWorkflowDialogOpen(false)
	}

	const [templateId, setTemplateId] = React.useState("")
	const [workflowTemplateDate, setWorkflowTemplateData] = React.useState([])
	const [isUsed, setIsUsed] = React.useState(false)
	const [isOnlyStep, setIsOnlyStep] = React.useState(false)

	const handleName = (e) => {
		formik.setFieldTouched('name', true)
		formik.setFieldValue("name", e.target.value)
	}
	const handleDescription = (e) => {
		formik.setFieldTouched('description', true)
		formik.setFieldValue("description", e.target.value)
	}

	const fetchTemplateData = () => {
		dispatch(getWorkflowTemplate("evaluate")).then((resp) => {
			if (resp?.fields && resp?.actions) {
				let workflowTemplateData = {
					actions: resp.actions,
					fields: resp.fields
				}
				setWorkflowTemplateData(workflowTemplateData)
			}
			if (mode !== "edit") {
				if (resp?.steps && resp?.steps?.length > 0) {
					// set default status
					let steps = [...resp.steps].map(item => {
						return {
							...item,
							status: "active"
						}
					})
					setStepList(steps)
					if (resp.steps[0]?.template_id) setTemplateId(resp.steps[0].template_id)
				}
			}
		})
	}

	const fetchWorkflowData = (step = false) => {
		if (id && id !== "") {
			setIsOnlyStep(step)
			dispatch(getWorkflow(id)).then(resp => {
				let workflow = resp?.workflow ?? null
				if (workflow) {
					setWorkflowData(workflow)
				}
			})
		}
	}

	const checkedLang = (data) => {
		if (previewLang === "EN") {
			if (data.en && data.en !== "") {
				return data.en
			} else {
				return data.th
			}
		} else {
			if (data.th && data.th !== "") {
				return data.th
			} else {
				return data.en
			}
		}
	}

	const [editStepData, setEditStepData] = React.useState({})
	const [typeWorkflowTemplate, setTypeWorkflowTemplate] = React.useState({})

	const handleEditStep = (step) => {
		let tmpStep = { ...step }
		if (mode === "edit") {
			dispatch(getWorkflowStep(step.id)).then(resp => {
				if (resp?.workflow_step?.id) {
					tmpStep = {
						...tmpStep,
						stepAssignId: resp?.workflow_step?.id
					}
				}
				setEditStepData(tmpStep, setIsEvaluationWorkflowDialogOpen(true))
				setTypeWorkflowTemplate("edit")
			})
		} else {
			setEditStepData(tmpStep, setIsEvaluationWorkflowDialogOpen(true))
			setTypeWorkflowTemplate("edit")
		}
	}

	const handleDeleteStep = (step) => {
		if (mode !== "edit") {
			let tmpList = [...stepList].filter(list => list.step !== step.step)
			setStepList(tmpList)
		} else if (mode === "edit") {
			dispatch(deleteWorkflowStep(step.id)).then(() => fetchWorkflowData(true))
		}
	}

	const handleSubmitForm = () => {
		formik.submitForm()
		dispatch({
			type: "SCROLL_TO_ERROR",
			payload: true,
		})
	}

	const handleSubmitDialog = (data) => {
		let tmpStepList = [...stepList]
		let findActions = searchActions(data.action)
		let findFields = searchFields(data.field)
		let findList = tmpStepList.find(item => item.step === data.step)
		if (findFields?.length > 0) {
			if (data?.value) {
				if (findList?.fields?.length > 1) {
					let tmpField = []
					findList.fields.forEach((item, index) => {
						if (item.code === "self") {
							tmpField.push(item)
						} else {
							tmpField.push(
								{
									...findFields[0],
									value: {
										code: data.value.code,
										id: data.value.value,
										name: data.value.oName
									}
								}
							)
						}
					})
					findFields = tmpField
				} else {
					findFields[0] = {
						...findFields[0],
						value: {
							code: data.value.code,
							id: data.value.value,
							name: data.value.oName
						},
					}
				}
			}
		}
		if (typeWorkflowTemplate === "edit") {
			if (mode !== "edit") {
				let newList = null
				if (data.step !== 1) {
					newList = {
						...findList,
						actions: findActions,
						fields: findFields,
						description: {
							en: data?.descriptionEN || "",
							th: data?.descriptionTH || ""
						},
						tooltip: {
							en: data?.tooltipEN || "",
							th: data?.tooltipTH || ""
						},
						is_send_mail: data?.emailNotice,
						options: {
							...findList.options,
							edit: data?.editable,
							hide_score_self: data?.hideScoreToSelf,
							reject: data?.reject
						}
					}
				} else {
					newList = {
						...findList,
						fields: findFields,
						description: {
							en: data?.descriptionEN || "",
							th: data?.descriptionTH || ""
						},
						tooltip: {
							en: data?.tooltipEN || "",
							th: data?.tooltipTH || ""
						},
						is_send_mail: data?.emailNotice,
						options: {
							...findList.options,
							edit: data?.editable,
							hide_score_self: data?.hideScoreToSelf,
							reject: data?.reject
						}
					}
				}
				tmpStepList = tmpStepList.map(old => (old.step === newList.step) ? newList : old)
				setStepList(tmpStepList, handleCloseWorkflowDialog())
			} else if (mode === "edit") {
				let newList = {
					step: data?.step,
					action: findActions?.code || "",
					field: findFields.length > 0 ? findFields[0].id : "",
					value: data?.value?.value || "",
					description_th: data?.descriptionTH || "",
					description_en: data?.descriptionEN || "",
					tooltip_th: data?.tooltipTH || "",
					tooltip_en: data?.tooltipEN || "",
					is_send_mail: data?.emailNotice,
					is_edit: data?.editable,
					is_hide_score_self: data?.hideScoreToSelf,
					is_reject: data?.reject,
				}
				dispatch(putWorkflowStep(data?.stepAssignId, newList)).then(resp => {
					handleCloseWorkflowDialog()
					fetchWorkflowData(true)
				})
			}
		} else if (typeWorkflowTemplate === "add") {
			if (mode !== "edit") {
				if (findFields?.length > 0) {
					if (data?.value) {
						findFields[0] = {
							...findFields[0],
							value: {
								code: data.value.code,
								id: data.value.value,
								name: data.value.oName
							},
						}
					}
				}
				let newList = {
					step: data?.step,
					action: findActions,
					fields: findFields,
					description: {
						en: data?.descriptionEN || "",
						th: data?.descriptionTH || ""
					},
					tooltip: {
						en: data?.tooltipEN || "",
						th: data?.tooltipTH || ""
					},
					is_send_mail: data?.emailNotice,
					options: {
						edit: data?.editable,
						hide_score_self: data?.hideScoreToSelf,
						reject: data?.rejct
					}
				}
				tmpStepList = [...stepList]
				tmpStepList.push(newList)
				setStepList(tmpStepList, handleCloseWorkflowDialog())
			} else if (mode === "edit") {
				let newList = {
					workflow_id: workflowId,
					step: data?.step,
					action: findActions?.code || "",
					field: findFields.length > 0 ? findFields[0].id : "",
					value: data?.value?.value || "",
					description_th: data?.descriptionTH || "",
					description_en: data?.descriptionEN || "",
					tooltip_th: data?.tooltipTH || "",
					tooltip_en: data?.tooltipEN || "",
					is_send_mail: data?.emailNotice,
					is_edit: data?.editable,
					is_hide_score_self: data?.hideScoreToSelf,
					is_reject: data?.reject,
				}
				dispatch(postWorkflowStep(newList)).then(resp => {
					handleCloseWorkflowDialog()
					fetchWorkflowData(true)
				})
			}
		}
	}

	const searchActions = (search) => {
		let result = [...workflowTemplateDate.actions].find(workflow => workflow.code === search)
		return result
	}

	const searchFields = (search) => {
		let result = [...workflowTemplateDate.fields].filter(workflow => workflow.code === search)
		return result
	}

	const formatStepList = (data) => {
		let resultArray = []
		let tmpObj = {
			// workflow_id: "",
			// id: "",
			// tooltip_th: "",
			// tooltip_en: "",
			// is_hide_score_self: false,
			// is_reject: false,
			// is_edit: false,
			// value: ""
		}
		if (data.length > 0) {
			data.sort((a, b) => a.step - b.step).forEach(item => {
				tmpObj = {
					...tmpObj,
					id: item.id,
					step: item.step,
					action: item?.action?.code,
					field: item?.fields?.length > 0 ? item.fields[0].id : "",
					description_th: item.description.th,
					description_en: item.description.en,
					tooltip_th: item.tooltip.th,
					tooltip_en: item.tooltip.en,
					status: item.status,
					is_send_mail: item.is_send_mail ?? false,
					is_edit: item?.options?.edit ?? false,
					is_hide_score_self: item?.options?.hide_score_self ?? false,
					is_reject: item?.options?.reject ?? false,
					template_id: item?.template_id ?? templateId
				}
				if (item.action !== "submit") {
					if (item?.fields?.length > 1) {
						let fields = item?.fields?.filter(item => item.code !== "self")
						if (fields.length > 0) {
							tmpObj = {
								...tmpObj,
								field: fields?.length > 0 ? fields[0].id : "",
							}
							if (fields?.[0]?.value && fields?.[0]?.value?.id) {
								tmpObj = {
									...tmpObj,
									value: fields?.[0]?.value?.id
								}
							}
						}
					} else {
						if (item?.fields?.[0]?.value && item?.fields?.[0]?.value?.id) {
							tmpObj = {
								...tmpObj,
								value: item?.fields?.[0]?.value?.id
							}
						}
					}
					if (item?.options?.is_edit || item?.options?.edit) {
						tmpObj = {
							...tmpObj,
							is_edit: item?.options?.is_edit || item?.options?.edit
						}
					}
				}
				resultArray.push(tmpObj)
			})
		}
		return resultArray
	}

	const [isSuccessCreateDialogOpen, setIsSuccessCreateDialogOpen] = React.useState(false)

	const handleSuccessCreateDialog = () => {
		setIsSuccessCreateDialogOpen(false, goToAdmin("/workflow"))
	}

	const handleSubmitCreate = () => {
		let formattedStepList = formatStepList(stepList)
		let data = {
			code: formik.values.code,
			type: formik.values.type,
			name: formik.values.name,
			status: formik.values.status ? "active" : "inactive",
			description: formik.values.description,
			type: formik.values.type.toLowerCase() === "evaluation" ? "evaluate" : formik.values.type,
			steps: formattedStepList,
		}
		dispatch(postCreateWorkflow(data)).then(resp => {
			setIsSuccessCreateDialogOpen(true)
		})
	}

	const [isSuccessUpdateDialogOpen, setIsSuccessUpdateDialogOpen] = React.useState(false)
	const handleSuccessUpdateDialog = () => {
		setIsSuccessUpdateDialogOpen(false, goToAdmin("/workflow"))
	}
	const handleSubmitUpdate = () => {
		let formattedStepList = formatStepList(stepList)
		let data = {
			code: formik.values.code,
			type: formik.values.type,
			name: formik.values.name,
			status: formik.values.status ? "active" : "inactive",
			description: formik.values.description,
			type: formik.values.type.toLowerCase() === "evaluation" ? "evaluate" : formik.values.type,
			steps: formattedStepList,
		}
		dispatch(putWorkflow(id, data)).then(() => {
			setIsSuccessUpdateDialogOpen(true)
		})
	}

	const setDataForEdit = (data) => {
		if (!isOnlyStep) {
			formik.setFieldValue("code", data?.code ?? "")
			formik.setFieldValue("type", data?.type ?? "")
			formik.setFieldValue("name", data?.name ?? "")
			formik.setFieldValue("status", data?.status === "active" ? true : false)
			formik.setFieldValue("description", data?.description ?? "")
		}
		setIsUsed(data?.is_used ?? false)
		setWorkflowId(data?.id || "")
		setStepList(data?.steps)
	}

	const handleSetEnable = (step) => {
		let tmpStepList = [...stepList].map(item => {
			if (item.step === step) {
				return {
					...item,
					status: item.status === "active" ? "inactive" : "active"
				}
			} else {
				return item
			}
		})
		setStepList(tmpStepList)
	}

	const reorder = (from, dest) => {
		let result = [...stepList]
		if (!dest) return result
		let pop = result.find((_, index) => index === from)
		result.splice(from, 1)
		result.splice(dest, 0, pop)
		result = result.map((item, index) => {
			return {
				...item,
				step: index + 1
			}
		})
		return result;
	}

	const sortList = ({ destination, source }) => {
		const reorderList = reorder(source.index, destination?.index)
		if (mode === "edit") {
			let formattedStepList = formatStepList(reorderList)
			let data = {
				code: workflowData?.code,
				type: workflowData?.type,
				name: workflowData?.name,
				status: workflowData?.status ? "active" : "inactive",
				description: workflowData?.description,
				type: "evaluate",
				steps: formattedStepList,
			}
			dispatch(putWorkflow(id, data)).then(() => {
				fetchWorkflowData(true)
			})
		} else {
			setStepList(reorderList)
		}
	}

	const mounted = useRef(false)
	// useEffect
	useEffect(() => {
		fetchTemplateData()
		fetchWorkflowData()
		mounted.current = true
		return () => {
			mounted.current = false;
		}
	}, [])

	useEffect(() => {
		if (mode === "edit" && workflowData) {
			setDataForEdit(workflowData)
		}
	}, [mode, workflowData])

	useEffect(() => {
		if (mode !== "edit") {
			formik.setFieldValue("code", state?.code ?? "")
			formik.setFieldValue("type", state?.type ?? "")
		}
	}, [state])


	useEffect(() => {
		setCountStep(stepList.length)
		const checkIsStepValid = () => {
			let result = stepList.findIndex(step => (step.action.code === "submit" && step.status === "active") || (step.action.code === "evaluate" && step.status === "active"))
			return result
		}
		setIsStepValid(checkIsStepValid() > -1)
	}, [stepList])

	// end useEffect

	return (
		<Grid container mt={3}>
			<Grid item xs={12}>
				<Grid container spacing={4}>
					<Grid item xs={12}>
						<StyledPaper>
							<Grid container mb={1} spacing={4}>
								<Grid item xs={6} display="flex" alignItems="center">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.code")}
									</Typography>
									<RedStarRequired />
								</Grid>
								<Grid item xs={6} display="flex" alignItems="center">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.type")}
									</Typography>
									<RedStarRequired />
								</Grid>
							</Grid>
							<Grid container mb={2} spacing={4}>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											backgroundColor: "#FAFAFA",
											"-webkit-text-fill-color": "#000 !important",
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
										},
										fieldset: { borderColor: "#FFFFFF !important" },
									}}
								>
									<TextField
										error={Boolean(formik.touched.code && formik.errors.code)}
										sx={{ mt: 0 }}
										fullWidth
										margin="normal"
										name="code"
										disabled
										type="text"
										maxLength={20}
										value={formik.values.code}
										InputLabelProps={{
											shrink: true,
										}}
									/>
									{Boolean(formik.touched.code && formik.errors.code) && <ErrorHelper />}
								</Grid>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											backgroundColor: "#FAFAFA",
											"-webkit-text-fill-color": "#000 !important",
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
											textTransform: "capitalize"
										},
										fieldset: { borderColor: "#FFFFFF !important" },
									}}
								>
									<TextField
										error={Boolean(formik.touched.type && formik.errors.type)}
										sx={{ mt: 0 }}
										fullWidth
										margin="normal"
										name="type"
										disabled
										type="text"
										value={formik.values.type}
										InputLabelProps={{
											shrink: true,
										}}
									/>
									{Boolean(formik.touched.type && formik.errors.type) && <ErrorHelper />}
								</Grid>
							</Grid>
							<Grid container mb={1} spacing={4}>
								<Grid item xs={6} display="flex" alignItems="center">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.name")}
									</Typography>
									<RedStarRequired />
								</Grid>
								<Grid item xs={6} display="flex" alignItems="center">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.status")}
									</Typography>
									<RedStarRequired />
								</Grid>
							</Grid>
							<Grid container mb={2} spacing={4}>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
										},
									}}
								>
									<TextField
										sx={{ my: 0 }}
										error={Boolean(formik.touched.name && formik.errors.name)}
										fullWidth
										margin="normal"
										placeholder={t("adminWorkflow.form.fillTheName")}
										name="name"
										type="text"
										value={formik.values.name}
										onChange={handleName}
										InputLabelProps={{
											shrink: true,
										}}
									/>
									{Boolean(formik.touched.name && formik.errors.name) && <ErrorHelper />}
								</Grid>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
										},
										"& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
											backgroundColor: "#D8D8D8!important"
										}
									}}
								>
									<IOSSwitch checked={formik.values.status} disabled={isUsed} onChange={() => formik.setFieldValue("status", !formik.values.status)} />
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{formik.values.status ? t("label.active") : t("label.inactive")}
									</Typography>
								</Grid>
							</Grid>
							<Grid container mb={1} spacing={4}>
								<Grid item xs={12} display="flex">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.description")}
									</Typography>
									<RedStarRequired />
								</Grid>
							</Grid>
							<Grid container mb={2} spacing={4}>
								<Grid
									item
									xs={12}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
										},
									}}
								>
									<TextField
										error={Boolean(formik.touched.description && formik.errors.description)}
										sx={{ my: 0 }}
										fullWidth
										margin="normal"
										placeholder={t("adminWorkflow.form.fillTheDescription")}
										name="description"
										type="text"
										value={formik.values.description}
										onChange={handleDescription}
										InputLabelProps={{
											shrink: true,
										}}
									/>
									{Boolean(formik.touched.description && formik.errors.description) && <ErrorHelper />}
								</Grid>
							</Grid>
						</StyledPaper>

						<Divider sx={{ my: 4 }} />

						<StyledPaper sx={{ mb: 4 }}>
							<Grid container spacing={4}>
								<Grid item xs={12} display="flex" flexDirection="column">
									<Grid container mb={1}>
										<Grid item xs={12} display="flex" alignItems="center" justifyContent="space-between">
											<Typography color="#404349" fontSize={18} fontWeight="500">
												{t("adminWorkflow.form.evaluationProcessPreview")}
											</Typography>
											<ToggleButtonGroup
												color="primary"
												value={previewLang}
												exclusive
												onChange={handleChangePreviewLang}
												aria-label="Platform"
												size="small"
												sx={{
													"& .MuiToggleButton-root": {
														width: "75px",
														height: "30px",
														fontWeight: 400,
														fontSize: 14,
														textTransform: "none",
													},
													"& .Mui-selected": { borderColor: "#5DA196" },
												}}
											>
												<ToggleButton value="EN">Eng</ToggleButton>
												<ToggleButton value="TH">Thai</ToggleButton>
											</ToggleButtonGroup>
										</Grid>
									</Grid>
									<Grid container mb={2}>
										<Grid item xs={12} display="flex" alignItems="center" >
											<CalendarIcon className={classes.calendarIcon} />
											<Typography color="#404349" fontSize={18} fontWeight="400" sx={{ ml: 1 }} >
												{t("adminWorkflow.form.signOffDueDate")}: 01 Jan 99
											</Typography>
										</Grid>
									</Grid>
									<Grid container>
										<Grid item xs={12} display="flex" alignItems="center">
											<Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
												{
													stepList.filter(step => step?.status === "active").map(item => {
														return (
															<>
																<div
																	style={{
																		maxWidth: "700px",
																		width: "100%",
																		height: "100%",
																		background: "rgba(93, 161, 150, 0.1)",
																		border: "1px solid #5DA196",
																		borderRadius: "5px",
																		position: "relative",
																	}}
																>
																	<Box
																		sx={{ p: 1, display: "flex", alignItems: "start" }}
																	>
																		<Box
																			mt="4px"
																			style={{
																				background: "#5DA196",
																				border: "1px solid #5DA196",
																				borderRadius: "50%",
																				width: "30px",
																				height: "30px",
																			}}
																			sx={{
																				display: "flex",
																				alignItems: "center",
																				justifyContent: "center",
																			}}
																		>
																			<ApprovedIcon />
																		</Box>
																		<Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
																			<Typography fontSize="16" fontWeight="600"
																				sx={{
																					color: "#404349"
																				}}
																			>
																				{checkedLang(item?.description)}
																			</Typography>
																		</Box>
																	</Box>
																	<Box
																		sx={{
																			px: 1,
																			display: "flex",
																			alignItems: "center",
																		}}
																	>
																		<Box
																			style={{
																				width: "30px",
																			}}
																		></Box>
																		<Box sx={{ ml: 2 }}>
																			<Typography fontSize="14px" fontWeight="400" color="#404349">
																				{`${t('label.formStatus')} : ${t('label.completed')}`}
																			</Typography>
																		</Box>
																	</Box>
																	<Box
																		sx={{
																			px: 1,
																			display: "flex",
																			alignItems: "center",
																		}}
																	>
																		<Box
																			style={{
																				width: "30px",
																			}}
																		></Box>
																		<Box sx={{ ml: 2 }}>
																			<Typography fontSize="14px" fontWeight="400" color="#404349">
																				{t('evaluation.submittedDate')}:
																			</Typography>
																		</Box>
																	</Box>
																	<Box
																		sx={{
																			px: 1,
																			pb: 1,
																			display: "flex",
																			alignItems: "center",
																		}}
																	>
																		<Box
																			style={{
																				width: "30px",
																			}}
																		></Box>
																		<Box sx={{ ml: 2 }}>
																			<Typography fontSize="14px" fontWeight="400" color="#404349">
																				{t('evaluation.dueDate')}:
																			</Typography>
																		</Box>
																	</Box>
																	<Box
																		style={{
																			position: "absolute",
																			right: 0,
																			top: 0,
																			margin: 6,
																		}}
																	>
																		<div style={{ width: "max-content" }}>
																			<BootstrapTooltip
																				placement="top"
																				title={checkedLang(item?.tooltip)}
																			>
																				<InfoIcon style={{ cursor: "pointer" }} />
																			</BootstrapTooltip>
																		</div>
																	</Box>
																</div>
																<Box
																	sx={{
																		borderTop: "3px dashed #E5E5E5",
																		width: "100%",
																		maxWidth: "65px",
																		"&:last-child": {
																			borderTop: "none",
																			width: "0px"
																		}
																	}}
																/>
															</>
														)
													})
												}

											</Box>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</StyledPaper>

						<StyledPaper>
							<Grid container>
								<Grid item xs={12}>
									<Grid container mb={2}>
										<Grid item display="flex" alignItems="center">
											<Typography color="#404349" fontSize={18} fontWeight="500">
												{t("adminWorkflow.form.workflowTemplate")}
											</Typography>
											<RedStarRequired />
										</Grid>
										{
											!isStepValid &&
											<Grid item display="flex" alignItems="center" ml={2}>
												<Box sx={{ display: "flex", alignItems: "center" }}>
													<AlertRed />
													<FormHelperText
														error={true}
														sx={{ ml: 1, fontSize: "14px", fontWeight: "500" }}
													>
														{t("adminWorkflow.label.pleaseSelectAtLeast1")}
													</FormHelperText>
												</Box>
											</Grid>
										}
									</Grid>
									<Grid container mb="30px">
										<Grid item display="flex" alignItems="center" xs={12}>
											<StyledTableEvaluate sx={{ width: "100%" }} data={stepList} doEdit={handleEditStep} doDelete={handleDeleteStep} setEnable={handleSetEnable} doSortList={sortList} isStepValid={isStepValid} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</StyledPaper>

						<Grid container mt={4} pr={4}>
							<Grid
								item
								display="flex"
								alignItems="center"
								xs="auto"
								ml="auto"
							>
								<Button
									size="small"
									aria-controls="cancle"
									aria-haspopup="true"
									color="black"
									variant="outlined"
									sx={{
										width: "114px",
										height: "45px",
										p: "0",
										textTransform: "none",
									}}
									onClick={() => setIsconfirmDiscardDialogOpen(true)}
								>
									<Typography fontWeight="500" fontSize={18} color="#6B6B6B">
										{t("label.cancel")}
									</Typography>
								</Button>
								<Button
									size="small"
									aria-controls="create"
									aria-haspopup="true"
									color="primary"
									variant="contained"
									disabled={!mounted.current || !isStepValid}
									sx={{
										width: "114px",
										height: "45px",
										p: "0",
										textTransform: "none",
										ml: "35px",
									}}
									onClick={() => handleSubmitForm()}
								>
									<Typography fontWeight="500" fontSize={18}>
										{mode === "edit" ? t("label.save") : t("label.create")}
									</Typography>
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<WorkflowDialog open={isWorkflowDialogOpen} workflowType="evaluate" onClose={handleCloseWorkflowDialog} editData={editStepData} addData={{ countStep: countStep, is_send_mail: true }} workflowTemplateData={workflowTemplateDate} type={typeWorkflowTemplate} doSubmit={handleSubmitDialog} />
			{/* success create dialog */}
			<MessageDialog
				open={isSuccessCreateDialogOpen}
				setValue={handleSuccessCreateDialog}
				title={t('adminWorkflow.dialog.successCreateTitle')}
				text={t('adminWorkflow.dialog.successCreateDesc')}
			/>
			{/* success edit dialog */}
			<MessageDialog
				open={isSuccessUpdateDialogOpen}
				setValue={handleSuccessUpdateDialog}
				title={t('adminWorkflow.dialog.successUpdateTitle')}
				text={t('adminWorkflow.dialog.successUpdateDesc')}
			/>
			{/* step empty */}
			<MessageDialog
				open={isStepListEmptyDialogOpen}
				setValue={setIsStepListEmptyDialogOpen}
				type="fail"
				title={t('adminWorkflow.dialog.errorStepListEmptyTitle')}
				text={t('adminWorkflow.dialog.errorStepListEmptyDesc')}
			/>
			{/* confirm discard */}
			<ConfirmDialog
				open={isConfirmDiscardDialogOpen}
				doConfirm={handleConfirmDiscard}
				warning={true}
				setValue={setIsconfirmDiscardDialogOpen}
				title={t("label.confirmationOfDiscard")}
				text={t("label.youSureDiscardChange")}
			/>
		</Grid>
	)
}

export default EvaluationWorkflow